import { ingenuity } from "@quest/base-core";
import { GameParserModel } from "../Platform/GameParserModel";
// import { gameConstants } from "../Constants/gameConstants";

export class CollectionModel {
  private pendingWins: string[];
  private currentWin: string;

  public getPendingWins(): string[] {
    return this.pendingWins;
  }

  public setPendingWins(value: string[]): void {
    this.pendingWins = value;
  }
  public getCurrentWin(): string {
    return this.currentWin;
  }

  public setCurrentWin(value: string): void {
    this.currentWin = value;
  }

  public getFishAnimId(collectionId: number, symbolId: number, win: boolean) {
    if (collectionId === 152) {
      switch (symbolId) {
        case 4:
          return win ? "orc_fish_2x2_fish_only" : "orc_fish_2x2_static-fish_only";
        case 6:
          return win ? "orc_fish_2x3_fish_only" : "orc_fish_2x3_static_fish_only";
        case 9:
          return win ? "orc_fish_3x3_fish_only" : "orc_fish_3x3_static_fish_only";
        case 12:
          return win ? "orc_fish_3x4_fish_only" : "orc_fish_3x4_static_fish_only";
        case 16:
          return win ? "orc_fish_4x4_fish_only" : "orc_fish_4x4_static_fish_only";
        case 20:
          return win ? "orc_fish_4x5_fish_only" : "orc_fish_4x5_static_fish_only";
      }
    } else {
      switch (symbolId) {
        case 4:
          return win ? "elf_fish_2x2_Fish_only" : "elf_fish_2x2_static_fish_only";
        case 6:
          return win ? "elf_fish_2x3_fish_only" : "elf_fish_2x3_static_fish_only";
        case 9:
          return win ? "elf_fish_3x3_fish_only" : "elf_fish_3x3_static_fish_only";
        case 12:
          return win ? "elf_fish_3x4_fish_only" : "elf_fish_3x4_static_fish_only";
        case 16:
          return win ? "elf_fish_4x4_fish_only" : "elf_fish_4x4_static_fish_only";
        case 20:
          return win ? "elf_fish_4x5_fish_only" : "elf_fish_4x5_static_fish_only";
      }
    }
  }

  public getCollectionName(fishID: number): string {
    if (fishID === 4 || fishID === 6) {
      return "newbie";
    } else if (fishID === 9 || fishID === 12) {
      return "exp";
    } else if (fishID === 16 || fishID === 20) {
      return "master";
    }
  }
  // to set previous amount i.e. amount during init or before the spin
  public getCollectionWinAmount(collectionId: number, collectionName: string): number {
    const meterMultipliers = (ingenuity.parserModel as GameParserModel).getCollectionMeter(collectionId);
    let winAmount = meterMultipliers[collectionName];
    return winAmount;
  }
  //to set current amount i.e. amount during feature awarded
  public getCollectionUpdatedWinAmount(collectionId: number, collectionName: string): number {
    const meterMultipliers = (ingenuity.parserModel as GameParserModel).getCollectionMeterData(collectionId);
    let winAmount = meterMultipliers[collectionName];
    return winAmount;
  }
}
